import React from 'react';

import { useKioskManager } from '../../../hooks/useKioskManager';
import ButtonStyled from '../button/Button';
import styles from './categoryButton.module.scss';

type CategoryButtonProps = {
  label: string;
  iconImage: string;
  onClick: () => void;
};

const CategoryButton: React.FC<CategoryButtonProps> = ({
  label,
  iconImage,
  onClick,
}) => {
  const { kiosk, kioskMode } = useKioskManager();
  return (
    <ButtonStyled
      onClick={onClick}
      className={`${styles.category_btn} ${
        kiosk && kioskMode && styles[kiosk.model]
      }`}
    >
      <img src={iconImage} alt={label} className={styles.category_btn__icon} />
      <div className={styles.category_btn__label}>{label}</div>
    </ButtonStyled>
  );
};
export default CategoryButton;
